import calc from '../calc/index.js';
import parserBrackets from '../parserbrackets.js';
import escapeRegExp from './_escaperegexp.js';
// outerHTML escapes & < > in text, and & " (newer browsers also < >) in attributes
function htmlForms(bracket) {
  var replace = function replace(string, from, to) {
    return string.split(from).join(to);
  };
  var amp = replace(bracket, '&', '&amp;');
  var text = replace(replace(amp, '<', '&lt;'), '>', '&gt;');
  var forms = [bracket, text, replace(amp, '"', '&quot;'), replace(text, '"', '&quot;')];
  return forms.filter(function (form, i) {
    return forms.indexOf(form) === i;
  });
}
// calc fills every field right away
var parserData = {};
// since Matreshka allows to change parser brackets via parserBrackets objects
// the parser needs to generate required regular expressions and escaped brackets every time
// when parseBindings is called
// to optimize this behavior parserData object is created
// it calculates needed data every time when parserBrackets are changed
// and when parseBindings function is called it uses previously generated regeps
// from parserData object
calc(parserData, {
  leftBracket: {
    source: {
      object: parserBrackets,
      key: 'left'
    }
  },
  rightBracket: {
    source: {
      object: parserBrackets,
      key: 'right'
    }
  },
  htmlLeftBrackets: {
    source: 'leftBracket',
    handler: htmlForms
  },
  escLeftBracket: {
    source: 'leftBracket',
    handler: escapeRegExp
  },
  escRightBracket: {
    source: 'rightBracket',
    handler: escapeRegExp
  },
  bindingReg: {
    source: ['escLeftBracket', 'escRightBracket'],
    handler: function handler(left, right) {
      return new RegExp(left + "\\s*(.+?)\\s*" + right, 'g');
    }
  },
  strictBindingReg: {
    source: ['escLeftBracket', 'escRightBracket'],
    handler: function handler(left, right) {
      return new RegExp("^" + left + "\\s*(.+?)\\s*" + right + "$", 'g');
    }
  }
}, {
  debounceCalc: false // we need to get new regexps immediately when brackets are changed
});
export default parserData;